module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Archive-47fd15cb5edd2989021a04e2c9544291.svg";